var _path, _path2, _path3, _rect, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 428,
    viewBox: "0 0 427 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.693 113.178l-.09 2.752h180.618c10.376 0 18.529 8.468 18.185 19.003l-6.222 190.353c-.347 10.601-9.161 19.177-19.607 19.177H80.307c-10.376 0-18.53-8.468-18.185-19.003l7.288-222.985c.346-10.6 9.16-19.177 19.607-19.177h80.847c10.376 0 18.529 8.468 18.185 19.003l-.356 10.877z",
    fill: "#FAC864",
    stroke: "#000",
    strokeWidth: 5.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.761 208.517l-21.559-5.442-304.525 68.021 8.085 62.578 8.085 10.883 296.44-2.72 10.779-13.604 2.695-119.716z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.085 167.303c-1.112-10.405 6.3-18.693 16.596-18.693h280.271c10.524 0 20.087 8.642 21.222 19.259l16.773 156.896c1.112 10.405-6.301 18.693-16.596 18.693H78.081c-10.525 0-20.089-8.641-21.224-19.259L40.085 167.303z",
    fill: "#FFE496",
    stroke: "#000",
    strokeWidth: 5.33
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.948,
    y: 2.65,
    width: 80.907,
    height: 32.757,
    rx: 2.665,
    transform: "matrix(1 0 .1063 .99433 65.26 178.419)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 5.33
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.015 102.286h59.288",
    stroke: "#000",
    strokeWidth: 5.33,
    strokeLinecap: "round"
  })));
}

export default SvgDocumentinline;